import { useMemo, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { toast } from 'react-toastify'
import useI18n from 'hooks/useI18n'
import { UnifiedLogin, SelectEntryArea, entryDestination, AREA_SELECTION_PATH } from 'services/unifiedLogin'
import { exposeStrapiError } from 'utils'
import { trackEvent } from 'services/analytics'

export default function useController() {
  const { t } = useI18n()
  const history = useHistory()
  const formRef = useRef()
  const busy = useRef(false)
  const [loading, setLoading] = useState(false)
  const formItems = useMemo(() => [
    { ref: 'identifier', id: 'login-identifier', placeholder: t('email'), required: true, full: true },
    { ref: 'password', id: 'login-password', placeholder: t('password'), type: 'password', required: true, full: true },
  ], [t])
  const options = useMemo(() => [{ title: t('login'), page: 'login' }, { title: t('register'), page: 'register' }], [t])
  const login = async () => {
    if (busy.current) return
    const form = formRef.current?.getForm()
    if (!form) return
    busy.current = true
    setLoading(true)
    try {
      const result = await UnifiedLogin({ identifier: form.identifier.trim(), password: form.password })
      if (result && exposeStrapiError(result)) return
      if (!result?.areas?.length) { toast.error(t('area_login_error')); return }
      if (entryDestination(result.areas) === AREA_SELECTION_PATH) history.replace(AREA_SELECTION_PATH)
      else {
        const destination = await SelectEntryArea(result.areas[0])
        // Retry access verification on the chooser if a grant changed mid-login.
        history.replace(destination || AREA_SELECTION_PATH)
        if (destination) trackEvent('login', { method: 'email' })
      }
    } catch { toast.error(t('area_login_error')) }
    finally { busy.current = false; setLoading(false) }
  }
  return { t, navigate: to => history.push(`/${to}`), loading, formRef, formItems, login, options }
}
